<template>
	<div class="zongti">
		<div class="bodyzong">
			<div class="top">
				<div class="topLeft"></div>
			</div>
			<div class="flex">
				<div class="cont">
					<div class="right">
					
						<el-table
							ref="multipleSelection"
							:data="commodityList"
							v-loading="loading"
							:element-loading-text="loading_text"
							:default-sort="{ prop: 'date', order: 'descending' }"
						>
							<el-table-column type="index" :index="getIndex" label="排序">
							</el-table-column>
							<el-table-column prop="name" label="商品类目"> </el-table-column>
							<el-table-column prop="number" label="创建时间">
								<template slot-scope="scope">
									<span>{{ scope.row.create_time }}</span>
								</template>
							</el-table-column>
							<el-table-column prop="cover" label="商品图片" align="center">
								<template slot-scope="scope">
									<img
										:src="scope.row.pic"
										alt=""
										class="comImg"
										style="width: 40%;"
									/>
								</template>
							</el-table-column>
							<el-table-column label="商品状态">
								<template slot-scope="scope">
									<el-tag
										type="success"
										effect="dark"
										v-if="scope.row.status == 1"
									>
										已上架
									</el-tag>
									<el-tag v-else type="danger" effect="dark">
										未上架
									</el-tag>
								</template>
							</el-table-column>
							<el-table-column
								prop="operate"
								label="操作"
								header-align="center"
							>
								<template slot-scope="scope">
									<!-- 编辑按钮 -->
									<el-button
										size="small"
										type="text"
										@click="handleEdit(scope.row)"
										>编辑</el-button
									>
									<!--  删除按钮 -->
									<el-button
										size="small"
										type="text"
										@click="handleDelete(scope.row.id)"
										>删除</el-button
									>
								</template>
							</el-table-column>
						</el-table>
						<el-pagination
							@current-change="handleCurrentChange"
							layout="total, prev, pager, next, jumper"
							:total="total_num"
						>
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
		<!-- 新增 -->
		
		<!-- 编辑 -->
		<el-dialog title="编辑商品类目" :visible.sync="editFormVisible">
			<el-form :model="editForm" ref="editForm" label-width="auto">
				<el-form-item label="商品类目">
					<el-input v-model="editForm.name" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="商品状态">
					<el-switch
						v-model="editForm.status"
						active-text="上架"
						inactive-text="下架"
						:active-value="1"
						:inactive-value="0"
						active-color="#13ce66"
						inactive-color="#ff4949"
					>
					</el-switch>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancel">取消</el-button>
				<el-button type="primary" @click="submitEditRow">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import {
	categoryList,
	editMessage,
	deleteNumber,
} from "@/api/market";
import { mapGetters, mapActions } from "vuex";
import { addImage } from "@/api/mall";
export default {
	// components: { smsTemplate },
	inject: ["reload"],
	computed: {
		...mapGetters(["token", "app_id", "merch_id"]),
	},
	data() {
		return {
			form: {
				name: "",
				type: "",
				category: "", //商品类目
				state: "",
			},
		
			editForm: {
				id: "",
				name: "",
				// image: {
				//   url: "",
				//   id: "",
				// },
				status: 0,
			},
			idx: 1,
			total_num: 0,
			keyword: "",
			// 是否显示新增窗口
			// dialogFormVisible: false,
			editFormVisible: false,
			addLoading: false,
			page: "1",
			sort_name: "",
			type: "",
			nowIDx: 0,
			loading: true,
			loading_text: "正在加载中...",
			tableData: [],
			fakefileList1: [],
			value: "",
			// 选中
			multipleSelection: [],
			commodityList: [],
			// 添加商品弹窗
			addProduct: false,
		};
  },
  props:{
    val:{
      type:Number,
      default:0
    }
  },
  watch:{
    dialogFormVisible(val){
      console.log('ssss',val)
    },
    val(val) {
      if(val == 1){
        console.log(val)
        this.getCommodityList()
      }
    }
  },
	created() {
		this.getCommodityList();
	},
	methods: {
		...mapActions(["sethttp"]),
		getIndex(index) {
			return 10 * (this.page - 1) + index + 1;
		},
		// 获取商品类目列表
		async getCommodityList() {
			try {
				const res = await categoryList({
					page: this.page,
					app_id: this.app_id,
				});
				if (res.code == 200) {
					if (res.data.total_num > 0) {
						this.loading = false;
            console.log(res.data);
            this.total_num = res.data.total_num
						this.commodityList = res.data.result;
					} else {
						this.loading = false;
					}
				} else {
					this.loading = false;
				}
			} catch (error) {
				console.log(error);
			}
		},
		beforeLogoUpload(file) {
			const isLt2M = file.size / 1024 / 1024 < 2;
			if (!isLt2M) {
				this.$message.error("上传Logo图片大小不能超过 2MB!");
			}
			return isLt2M;
		},
		//上传图片
		productUploadImg(file) {
			console.log(file);
			var that = this;
			var formdata = new FormData();
			formdata.append("token", that.token);
			formdata.append("image", file.file);
			formdata.append("type", "1");
			formdata.append("file_group", "1");
			addImage(formdata).then((res) => {
				if (res.code == 200) {
					this.addForm.image = res.data;
				} else {
					this.$message({
						message: res.msg,
						type: "warning",
					});
				}
			});
		},
		handleAvaterChange(file, fileList) {
			this.editForm.image.url = URL.createObjectURL(file.raw);
		},
		// 删除图片
		handleRemove(file) {
			console.log(file);
			var replaceArr = [];
			replaceArr = this.fakefileList1;
			console.log(replaceArr);
			for (var i = 0; i < replaceArr.length; i++) {
				if (file.uid == replaceArr[i].uid) {
					replaceArr.splice(i, 1);
					this.chosepictireid1.splice(i, 1);
					this.image_id = this.chosepictireid1.join(",");
					console.log(this.formData.images, "delete list1 item");
					break;
				}
			}
		},
	
		// 取消按钮
		cancel() {
        this.$emit('add',false)
			// this.dialogFormVisible = false;
			this.editFormVisible = false;
		},

		handleCurrentChange(val) {
			this.page = val;
		},
		// 编辑
		handleEdit(row) {
			this.editFormVisible = true;
			this.editForm.id = row.id;
			this.editForm.name = row.name;
			this.editForm.status = row.status;
			// this.editForm = Object.assign({}, row);
			// // 每一行的数据值
			// this.app_id = row.app_id;
			// this.id = row.id;
			// this.name = row.name;
			// this.image = row.image;
			// this.status = row.status;
		},
		// 保存编辑
		async submitEditRow() {
			const data = await editMessage({
				app_id: this.app_id,
				id: this.editForm.id,
				name: this.editForm.name,
				// logo: image.id,
				status: this.editForm.status,
			});
			console.log(data);
			if (data.code == 200) {
				this.$message({
					message: "修改成功",
					type: "success",
				});
			} else {
				this.$message({
					message: data.msg,
					type: "error",
				});
			}
			this.getCommodityList();
			this.editFormVisible = false;
		},
		// 删除
		handleDelete(id) {
			console.log("--------");
			console.log(id);
			this.$confirm("此操作永久删除该商品，是否继续?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(async (res) => {
					const data = await deleteNumber({
						id: id,
					});
					console.log(data);
					this.getCommodityList();
					if (data.code == 200) {
						this.$message({
							type: "success",
							message: "删除成功！",
						});
					}
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消删除",
					});
				});
		},
		// change
		change(index) {
			this.type = index;
		},
		// 选中的商品
		handleSelectionChange(val) {
			this.multipleSelection = val;
			console.log(this.multipleSelection);
		},
		// 商品来源去向
		newCommodityCategory() {
			this.$router.push("optionProduction");
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`);
			this.page = val;
			this.getCommodityList();
		},
	},
};
</script>
<style scoped>
.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}
.avatar-uploader .el-upload:hover {
	border-color: #409eff;
}
.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 178px;
	height: 178px;
	line-height: 178px;
	text-align: center;
}
.avatar {
	width: 182px;
	height: 182px;
	display: block;
}
</style>
<style lang="scss" scoped>
.center {
	width: 100%;
	display: flex;
	justify-content: center;
}

.padding {
	padding: 20px;
}
.zongti {
	height: 100%;
	padding: 0 55px 30px 30px;
	// background: #397dff;

	.bodyzong {
		height: 100%;
		.top {
			// min-height: 60px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			.topLeft {
				height: auto;
			}
		}
		.selectBtn {
			background: #397dff;
			color: #fff;
			cursor: pointer;
		}
	}
	.filtrate {
		height: 36px;
		.top-right {
			display: flex;
			align-items: center;
			justify-content: space-between;
		}
	}
	.cont {
		width: 100%;
		height: px;
		display: flex;
		justify-content: space-around;
	}
	.left {
		width: 140px;
		margin-right: 15px;
		border: 1px solid #ebeef5;
		li {
			width: 100%;
			line-height: 50px;
			padding: 0 15px;
			border-bottom: 1px solid #ebeef5;
			cursor: pointer;
		}
		li:first-child {
			background: #fafafa;
		}
		.current {
			background: #fafafa;
		}
	}
	.right {
		flex: 1;
		display: flex;
		overflow: hidden;
		flex-direction: column;
		.page {
			height: 50px;
			display: flex;
			align-items: center;
		}
		.el-table {
			flex: 1;
			margin-top: 20px;
			overflow-y: auto;
			border: 1px solid #ebeef5;
		}
		.el-form-item__label {
			padding: 4px 12px 0 0;
		}
		.el-input {
			width: 100%;
			position: relative;
			top: 2px;
		}
		.el-input__inner {
			height: 33px;
		}
		.comPrice {
			display: flex;
			flex-direction: row;
			align-items: center;
			// justify-content: center;
			.img {
				width: 50px;
				height: 50px;
				overflow: hidden;
				line-height: 50px;
				.comImg {
					vertical-align: middle;
					width: 50px;
				}
			}
			.rgt {
				width: 60px;
				height: 50px;
				margin-left: 10px;
				display: flex;
				flex-direction: column;
				justify-content: space-around;
				font-size: 14px;
				text-align: left;
				.name {
					color: rgba(3, 87, 255, 1);
					font-weight: 400;
					line-height: 21px;
					max-width: 100px;
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
				}
				.price {
					color: rgba(255, 91, 3, 1);
					font-weight: 400;
					line-height: 21px;
				}
			}
		}
		.el-pagination {
			height: 60px;
			padding-top: 16px;
		}
		.rowOption {
			.el-button {
				margin: 0 10px 10px 0;
			}
		}
	}
}
</style>

<style lang="scss">
.manage {
	.el-button--small {
		padding: 9px 27px;
	}
	.cell {
		text-align: center;
	}
}
</style>
